import DOMPurify from 'dompurify'

// Список совпадает с ADMIN_MESSAGE_TAGS в backend/client/ChannelSenders.php: это всё, что умеет редактор сообщений
const ALLOWED_TAGS = ['p', 'div', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'ul', 'ol', 'li', 'a']
const ALLOWED_ATTR = ['href']

// Ссылки открываем в новой вкладке, rel не даёт чужой странице управлять вкладкой портала
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

// Очистка HTML перед v-html: остаётся только разметка редактора
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html ?? '', { ALLOWED_TAGS, ALLOWED_ATTR })
}
